'use memo';

import type { ComponentType } from 'react';
import { ExpiryDueAlert } from './-ExpiryDueAlert';
import { useContractAlertCount } from './-query';

/**
 * 契約アラートのカテゴリ定義。
 *
 * 新しいアラートを追加するときは、ここに 1 エントリ足すだけでよい：
 *   1. `CONTRACT_ALERT_CATEGORY_KEYS` にキーを追加（URL `?category=` の値・型の源泉）
 *   2. `CONTRACT_ALERT_CATEGORIES` に { label, Content } を追加（サイドバー表示＋中身）
 *   3. 中身を表示するコンポーネントを 1 ファイル作る（例: ExpiryDueAlert）
 *
 * equipment アラート画面の「カテゴリ＝キー配列 + URL param」方式に倣っている。
 */
export const CONTRACT_ALERT_CATEGORY_KEYS = ['EXPIRY_DUE'] as const;
export type ContractAlertCategoryKey = (typeof CONTRACT_ALERT_CATEGORY_KEYS)[number];
export const DEFAULT_CONTRACT_ALERT_CATEGORY: ContractAlertCategoryKey = 'EXPIRY_DUE';
type ContractAlertCategory = {
  /** サイドバー表示ラベルの i18n キー（keyPrefix: pages.contract.list 配下） */
  labelKey: string;
  /** 右ペインに表示する中身 */
  Content: ComponentType;
  /** サイドバーのバッジ用件数フック（読み込み中は undefined） */
  useCount: () => number | undefined;
};
function useExpiryDueCount(): number | undefined {
  const {
    data,
    isPending
  } = useContractAlertCount();
  return isPending ? undefined : data?.EXPIRY_DUE;
}
export const CONTRACT_ALERT_CATEGORIES: Record<ContractAlertCategoryKey, ContractAlertCategory> = {
  EXPIRY_DUE: {
    labelKey: 'alerts.expiryDue.label',
    Content: ExpiryDueAlert,
    useCount: useExpiryDueCount
  }
};